export class Utility {
  static isUserTokenExpired(exp: number): boolean {
    return exp ? new Date(exp * 1000) < new Date() : true;
  }

  static convertToPascalCase = (str: string) => {
    if (str) {
      if (str.length === 1) {
        return str.toUpperCase();
      } else if (str.length > 1) {
        let words = str.split(" ");
        for (var i = 0; i < words.length; i++) {
          words[i] =
            words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
        }
        return words.join(" ");
      }
    }
    return "";
  };

  /**
   * Convert seconds.
   * @returns Converted seconds to hours,minutes,seconds.
   */
  static getTimeRemaining(totalSecs: number) {
    var hours = Math.floor(totalSecs / (60 * 60));

    var divisor_for_minutes = totalSecs % (60 * 60);
    var minutes = Math.floor(divisor_for_minutes / 60);

    var divisor_for_seconds = divisor_for_minutes % 60;
    var seconds = Math.ceil(divisor_for_seconds);
    return {
      totalSecs,
      hours,
      minutes,
      seconds,
    };
  }

  static isNotEmptyOrNull(value?: string) {
    if (
      value != null &&
      value !== undefined &&
      value !== "" &&
      value.replaceAll(" ", "") !== ""
    ) {
      return true;
    } else {
      return false;
    }
  }

  static getSubscriptionType(value?: string) {
    if (value?.toLowerCase().includes("single")) {
      return "Single";
    } else if (value?.toLowerCase().includes("team")) {
      return "Team";
    } else {
      return "";
    }
  }

  static ConvertToDateTime(value: string) {
    const utcDateTimeString = `${value}Z`;
    const dateTime = new Date(utcDateTimeString);
    const date =
      dateTime.getDate() < 10 ? "0" + dateTime.getDate() : dateTime.getDate();
    const month =
      dateTime.getMonth() + 1 < 10
        ? "0" + (dateTime.getMonth() + 1)
        : dateTime.getMonth() + 1;
    const year =
      dateTime.getFullYear() < 10
        ? "0" + dateTime.getFullYear()
        : dateTime.getFullYear();
    const hour =
      dateTime.getHours() < 10
        ? "0" + dateTime.getHours()
        : dateTime.getHours();
    const minutes =
      dateTime.getMinutes() < 10
        ? "0" + dateTime.getMinutes()
        : dateTime.getMinutes();
    return `${date}/${month}/${year} ${hour}:${minutes}`;
  }

  static ConvertToDate(value: string) {
    const utcDateTimeString = `${value}Z`;
    const dateTime = new Date(utcDateTimeString);

    const date =
      dateTime.getUTCDate() < 10
        ? "0" + dateTime.getUTCDate()
        : dateTime.getUTCDate();
    const month =
      dateTime.getUTCMonth() + 1 < 10
        ? "0" + (dateTime.getUTCMonth() + 1)
        : dateTime.getUTCMonth() + 1;
    const year =
      dateTime.getUTCFullYear() < 10
        ? "0" + dateTime.getUTCFullYear()
        : dateTime.getUTCFullYear();

    return `${date}-${month}-${year}`;
  }

  static getFileNameFromResponseHeaders(headers: any) {
    let contentDisposition = headers?.get("Content-Disposition");
    var filename = "";
    if (contentDisposition && contentDisposition.indexOf("attachment") !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(contentDisposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, "");
      }
    }
    return filename;
  }
}
